import * as lexActionType from '../actionsType/lexEnrolled.actionType';

export const initialState = {
    status: lexActionType.FETCHING_LEX_ENROLLED,
    response: false,
    exception: null
};

export function lexEnrolledReducer(state = initialState, action) {
    switch (action.type) {
        case lexActionType.FETCHING_LEX_ENROLLED:
            return {...state, status: lexActionType.FETCHING_LEX_ENROLLED};
        case lexActionType.LEX_ENROLLED_SUCCESS:
            return {...state, response: action.payload, status: lexActionType.LEX_ENROLLED_SUCCESS};
        case lexActionType.LEX_ENROLLED_ERROR:
            return {...state, status: lexActionType.LEX_ENROLLED_ERROR};
        default:
            return state;
    }
}
